import { useEffect } from "react";
import { crmApi } from "../../features/crm/api";
import { Sidebar } from "./Sidebar";
import { CLIENT_SIDEBAR_SECTIONS } from "./sidebar-config";
import { useAuth, useHasPermission } from "../../context/AuthContext";
import { canAccessChatbot, canAccessCrm, canAccessInboundCalling, canAccessKnowledge, canAccessProducts, canAccessSupervision, canAccessVoiceCloning, canAccessWorkflows, isAdminUser, isTimelinerUser } from "../../lib/userAccess";

export function ClientSidebar() {
  const { user } = useAuth();
  const canViewCallAnalytics = useHasPermission("call_analytics.view");

  // Attendance heartbeat (Phase 2B #7): one beat on mount, then every five
  // minutes while the app is open. Best-effort and CRM-gated — a failure
  // must never break navigation.
  useEffect(() => {
    if (!canAccessCrm(user)) return;
    const beat = () => { crmApi.presenceHeartbeat().catch(() => undefined); };
    beat();
    const interval = window.setInterval(beat, 5 * 60_000);
    return () => window.clearInterval(interval);
  }, [user]);

  const navSections = CLIENT_SIDEBAR_SECTIONS.map(section => ({
    ...section,
    items: section.items
      .map(item => {
        if (item.children) {
          const filteredChildren = item.children.filter(child => {
            if (child.href.startsWith("/call-analytics")) {
              return canViewCallAnalytics;
            }
            return true;
          });
          return { ...item, children: filteredChildren };
        }
        return item;
      })
      .filter(item => {
        if (item.label === "Audit & Billing") {
          return user?.audit_and_billing !== false;
        }
        if (item.label === "Supervisor") {
          return canAccessSupervision(user);
        }
        if (item.label === "Call Analytics" || item.label === "Call Intelligence") {
          return canViewCallAnalytics;
        }
        if (item.label === "Workflows") {
          return canAccessWorkflows(user);
        }
        if (item.label === "SFA") {
          return canAccessCrm(user);
        }
        if (item.label === "WhatsApp" || item.label === "Chatbot") {
          return canAccessChatbot(user);
        }
        if (item.label === "Knowledge") {
          return canAccessKnowledge(user);
        }
        if (item.label === "Voices") {
          return canAccessVoiceCloning(user);
        }
        if (item.label === "Products") {
          return canAccessProducts(user);
        }
        if (item.label === "Timeliner") {
          return isAdminUser(user) || isTimelinerUser(user);
        }
        if (item.label === "Inbound Calling" || item.label === "Phone Numbers") {
          return canAccessInboundCalling(user);
        }
        return true;
      })
  })).filter(section => section.items.length > 0);

  return (
    <Sidebar
      homePath="/"
      initialOpenGroups={["Batch Workspace", "Analytics"]}
      navSections={navSections}
    />
  );
}
